import { useEffect, useState } from 'react';
import { nowIsoInTimezone } from '@/utils/datetime';

const REFRESH_MS = 60_000;

/** Поточний місцевий час у поясі ("YYYY-MM-DDTHH:MM:SS"), оновлюється щохвилини. */
export function useNowInTimezone(timezone?: string | null): string {
  const [nowIso, setNowIso] = useState(() => nowIsoInTimezone(timezone));

  useEffect(() => {
    setNowIso(nowIsoInTimezone(timezone));
    const timer = window.setInterval(() => setNowIso(nowIsoInTimezone(timezone)), REFRESH_MS);
    return () => window.clearInterval(timer);
  }, [timezone]);

  return nowIso;
}
